import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loginRedirect = router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });

  // Fast path: signal already confirms authenticated.
  if (authService.isAuthenticated() === true) {
    return true;
  }

  // Slow path: resolve from token storage / refresh cookie.
  return authService.ensureAuthenticated().pipe(
    take(1),
    map((isAuthenticated) => (isAuthenticated ? true : loginRedirect)),
    catchError(() => of(loginRedirect))
  );
};
